export default __webpack_public_path__ + "static/media/list-icon.e31af1d7.svg";